<template>
  <div class="expinet-header d-flex align-items-center justify-content-between bg-sachlich-white py-1">
    <div>
      <ExpiButton 
        button-classes="fw-bold ms-2"
        icon-classes="fa fa-chevron-left"
        label-id="Zur EXPInet Startseite"
        :click="redirectToExpinetHome"
      />
    </div>
    <img
      src="../../static/aida-logo.svg"
      @click="redirectToExpinetHome"
    >
    <Agency />
  </div>
</template>

<script lang="ts">
import { IDomainList } from '@/store/app/interfaces';
import { defineComponent } from 'vue';
import Agency from './common/Agency.vue';
import ExpiButton from './common/ExpiButton.vue';

export default defineComponent({
  components: { Agency, ExpiButton },

  methods: {
    redirectToExpinetHome: () => {
      const homeURL: IDomainList = {
        prod: 'https://www.expinet.de',
        test: 'https://test-expinet.aida.de',
        dev: 'https://test-expinet.aida.de',
      }
      window.location.href = homeURL[process.env.STAGE as keyof IDomainList]!
    },

    getTranslateText: (label: string) => {
      return label
    }
  },
})
</script>

<style lang="scss" scoped>
@import '../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.expinet-header {
  border-bottom: 1px solid $color-aida-border;
}

img {
  height: 25px;

  &:hover {
    cursor: pointer;
  }
}
</style>